import {
  ORIGIN,
  DESTINATION,
} from 'components/modules/pricing/lane-rates-v2/lane-rates-v2-constants';

export const createErrorMessage = (error) => {
  const SPACER = ' - ';
  const row = error.row || '';
  const message = error.message ? SPACER.concat(error.message) : '';
  const cause = error.cause ? SPACER.concat(error.cause) : '';
  return 'Lane Rate '.concat(row).concat(cause).concat(message);
  // Lane Rate 1 - XX - invalid state
  // Lane Rate 3 - customerId - customerId is required
};

export const getLocationFields = (type) => {
  if (type === DESTINATION) {
    return {
      customZoneField: 'destinationZone',
      customZoneNameField: 'destinationZoneName',
      stateField: 'destinationState',
      cityField: 'destinationCity',
      zipField: 'destinationZip',
    };
  }
  return {
    customZoneField: 'originZone',
    customZoneNameField: 'originZoneName',
    stateField: 'originState',
    cityField: 'originCity',
    zipField: 'originZip',
  };
};

export const getDefaultLocationFields = (type) => {
  if (!type) {
    return null;
  }
  if (type === DESTINATION) {
    return {
      destinationZone: null,
      destinationZoneName: null,
      destinationCity: null,
      destinationZip: null,
    };
  }
  if (type === ORIGIN)
    return {
      originZone: null,
      originZoneName: null,
      originCity: null,
      originZip: null,
    };
};

export const isZipCode = (location) => {
  const US_ZIP_REGEX = /^\d+$/;
  return US_ZIP_REGEX.test(location);
};

export const laneRatesMapper = (laneRates) => {
  if (!laneRates || !Array.isArray(laneRates)) {
    return [{}];
  }

  const mappedLaneRates = laneRates.map((laneRate) => {
    const entries = Object.entries(laneRate);
    entries.forEach((entry) => {
      const [key, laneRateValue] = entry;
      if (laneRateValue === 'NULL') {
        // city/zip/customZone are coalesced into one field on the form
        // prevents "NULL" from displaying in this field
        delete laneRate[key];
      }
    });
    return {
      ...laneRate,
      customerName: laneRate.name,
      customerId: laneRate.customer,
    };
  });
  return mappedLaneRates;
};
